<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
      <form [formGroup]="deviceForm" novalidate>
        <table class="table table-condensed">
            <tbody>
                <tr>
                  <td class="col-sm-6 no-left-padding">
                          <table formArrayName="referencesForm" class="table table-inner table-condensed">
                              <tbody>
                                  <tr>
                                      <th>Clinical Investigation Reference Number</th>
                                      <th>Non-EU Applicable Countries</th>
                                  </tr>
                                  <tr formGroupName="{{i}}"
                                      *ngFor="let substance of referencesForm.controls; let i = index">
                                      <td
                                      [ngClass]="isDefault('Clinical Investigation References')">
                                        <label controlName="investigationNumber"></label>
                                      </td>
                                      <td
                                      [ngClass]="isDefault('Clinical Investigation References')">
                                        <label controlName="applicableCountry"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                  </td>
                <td class="col-sm-6"></td>
              </tr>
            </tbody>
        </table>
        <table class="table table-condensed">
            <tbody>
                <tr>
                    <td class="col-sm-12 no-left-padding no-right-padding">
                            <table formArrayName="certificateForm" class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Certificate Type</th>
                                        <th>Certificate Number</th>
                                        <th>Certificate Revision Number</th>
                                        <th>Notified Body ID</th>
                                        <th>Expiry Date</th>
                                    </tr>
                                    <tr formGroupName="{{i}}"
                                        *ngFor="let substance of certificateForm.controls; let i = index">
                                        <td
                                        [ngClass]="isDefault('Certificates')">
                                            <label controlName="certType"></label>
                                        </td>
                                        <td
                                        [ngClass]="isDefault('Certificates')">
                                            <label controlName="certNumber"></label>
                                        </td>
                                        <td
                                        [ngClass]="isDefault('Certificates')">
                                            <label controlName="certRevisionNumber"></label>
                                        </td>
                                        <td
                                        [ngClass]="isDefault('Certificates')">
                                            <label controlName="certBody"></label>
                                        </td>
                                        <td
                                        [ngClass]="isDefault('Certificates')">
                                            <label controlName="certExpDate"></label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                    </td>
                </tr>
            </tbody>
        </table>
      </form>
  </div>
</div>


